const development = Object.freeze({
  environmentName: "development",
  vercel: Object.freeze({
    projectName: "sozo-ai-development",
    projectId: "prj_V5CQP1DHGLjAhQd9VgVPUhwFgnMk",
  }),
  appUrl: "https://ai-agent-platform-develop.mazrica.com",
});

const production = Object.freeze({
  environmentName: "production",
  vercel: Object.freeze({
    projectName: "sozo-ai-production",
    projectId: "prj_aM9xncxjAYOVAjTCrrPY24xICnjA",
  }),
  appUrl: "https://ai-agent-platform.mazrica.com",
});

export const PUBLIC_DEPLOYMENT_CONFIGS = Object.freeze({
  development,
  production,
});

export function resolveDeploymentEnvironment(environment) {
  const resolvedEnvironments = new Set(
    [
      environment["NEXT_PUBLIC_VERCEL_PROJECT_ID"],
      environment["VERCEL_PROJECT_ID"],
    ]
      .filter((value) => typeof value === "string" && value.trim())
      .map((value) => {
        const projectId = value.trim();
        const config = Object.values(PUBLIC_DEPLOYMENT_CONFIGS).find(
          (candidate) => candidate.vercel.projectId === projectId,
        );
        if (!config) throw new Error(`Unknown Vercel project ID: ${projectId}`);
        return config.environmentName;
      }),
  );
  if (resolvedEnvironments.size > 1) {
    throw new Error("Conflicting Vercel project ID markers");
  }
  return resolvedEnvironments.values().next().value;
}
